import DateUtils from '@cobliteam/base-components/src/DateUtils';

import cn from '../../../utils/cn';

interface DatePickerDayProps {
  day: number;
  date?: Date;
  startDate?: Date | null;
  endDate?: Date | null;
  dateHover?: Date | null;
}

const DatePickerDay = ({
  day,
  date,
  startDate,
  endDate,
  dateHover,
}: DatePickerDayProps) => {
  const isStartDate = DateUtils.isSameDate(date, startDate);
  const isEndDate = DateUtils.isSameDate(date, endDate);

  const isSameDateHover =
    !endDate && DateUtils.isSameDate(startDate, dateHover);
  const isSameDate =
    DateUtils.isSameDate(startDate, endDate) || isSameDateHover;

  const isInDateRangeHover =
    !endDate && DateUtils.isBetweenDates(date, startDate, dateHover);
  const isInDateRange =
    DateUtils.isBetweenDates(date, startDate, endDate) || isInDateRangeHover;

  return (
    <div
      className={cn([
        'flex h-8 w-8 items-center justify-center rounded hover:bg-gray-lightest',
        isInDateRange &&
          'rounded-none bg-primary-light text-white hover:bg-primary-light',
        isStartDate &&
          'rounded-l rounded-r-none bg-primary font-bold text-white hover:bg-primary',
        isEndDate &&
          'rounded-l-none rounded-r bg-primary font-bold text-white hover:bg-primary',
        isSameDate && 'rounded',
      ])}
    >
      {day}
    </div>
  );
};

export default DatePickerDay;
